// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--YHX20","image":"styles-module--image--2wuhR","textContainer":"styles-module--textContainer--2Xv-w"};